//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from 'vuex'
import TabUserMsg from '@/components/tab/TabUserMsg.vue'
import UserMsgPosts from '@/pages/user-msg/UserMsgPosts'
import UserMsgLikePosts from '@/pages/user-msg/UserMsgLikePosts'
import UserMsgChannelCount from '@/pages/user-msg/UserMsgChannelCount'
import UserMsgLists from '@/pages/user-msg/UserMsgLists'
import { Post, User } from '@/models'
import { setTimeout } from 'timers';

export default {
  data () {
    return {
      // listOri: [
      //   '按时间',
      //   '按频道',
      //   // 'TA喜欢',
      //   '诗单 ' // publicListsCount
      // ],
      postLikeListCount: null,
      selectedIndex: 0,
      loadedLikeList: false,
      updateFlag: true 
    }
  },

  metaInfo() {
    return {
      title: this.userMsg && this.userMsg.username || "个人中心",
      titleTemplate: null,
      meta: [{ name: "description", content: "个人中心" }]
    };
  },

  // 当发生同页面跳转的时候进行 数据的初始化
  beforeRouteUpdate (to, from, next) {
    this.updateFlag = false 

    User.getMiniDataById(to.params.userId).then(userMsg => {
      this.setUserMsg(userMsg)
      this.updateFlag = true 
    })

    next()
  },

  methods: {
    ...mapMutations(['setUserMsg']),

    clickBarItem (index) {
      setTimeout(() => {
        this.selectedIndex = index
      }, 300)
    }
  },
  
  created () {

    // 如果状态中存在userMsg但是与路由的userId不同，重新请求 // 切换的情景
    if (this.userMsg && this.userMsg.objectId !== this.$route.params.userId) {
      this.updateFlag = false 

      User.getMiniDataById(this.$route.params.userId).then(userMsg => {
        this.setUserMsg(userMsg)
        this.updateFlag = true
      })
    }

    // 如果状态中不存在userMsg，重新请求  // 直接刷新的情景
    if (!this.userMsg) {
      User.getMiniDataById(this.$route.params.userId).then(userMsg => {
        // console.log('userMsg', userMsg)
        this.setUserMsg(userMsg)
      })
    }
  },

  computed: {
    ...mapGetters(['userMsg']),

    list () {
      // // 若缓存本页面，list 需要在每次重新进入时刷新
      // if (this.userMsg) {
      //   this.listOri[3] = "诗单" + this.userMsg.publicListsCount
      // }

      // return this.listOri

      return [
        '按时间',
        '按频道',
        // 'TA喜欢',
        '诗单 ' + this.userMsg.publicListsCount // publicListsCount
      ]
    }
  },

  components: {
    TabUserMsg,
    UserMsgPosts,
    UserMsgLikePosts,
    UserMsgChannelCount,
    UserMsgLists
  }
}  



// WEBPACK FOOTER //
// ./src/pages/user-msg/UserMsg.vue